import { render, staticRenderFns } from "./book-new.vue?vue&type=template&id=07564cb4&scoped=true"
import script from "./book-new.vue?vue&type=script&lang=js"
export * from "./book-new.vue?vue&type=script&lang=js"
import style0 from "./book-new.vue?vue&type=style&index=0&id=07564cb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07564cb4",
  null
  
)

export default component.exports